import Icon from "components/atom/Icon.tsx";
import { useCallback, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "config/store";
import { useTranslation } from "react-i18next";
import { USER_TYPES } from "globals/constants.ts";

function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentUser = useAppSelector(state => state.auth.user);
  const [clickedFeaturedCount, setClickedFeaturedCount] = useState<number>(0);
  const featuredEventIds: number[] = useAppSelector(state => state.search.featuredEventIds);


  const isHomePage = false;//for now
  /* const isHomePage = useMemo(() => {
     return false;
     if (location.pathname === "/") {
       return true;
     }
     return false;
  }, [location.pathname]);*/

  const currentSection = useMemo<"map" | "user" | "index" | "featured">(() => {
    if (location.pathname.startsWith("/profile")) {
      return "user";
    }
    if (location.pathname === '/contact'){
      return "user";
    }
    if (location.pathname === "/") {
      return "index";
    }
    if (location.pathname === "/featured") {
      return "featured";
    }
    return "map";
  }, [location.pathname]);

  const onClick = useCallback((section: "map" | "user" | "index" | "featured") => {
    if (section === "map") {
      navigate("/map");
    } else if (section === "featured") {
      navigate("/featured");
      setClickedFeaturedCount(prev => prev + 1)
    } else if (section === "index") {
      navigate("/");
    } else if (section === "user") {
      if (currentUser) {
        //block access if user is not completed and has not a verified email
        if (currentUser.unverifiedEmail && currentUser.type === USER_TYPES.EVENT_MANAGER && currentUser.email === currentUser.unverifiedEmail) {
          navigate({
            pathname: "/map",
            hash: "#/auth/verify-email"
          }, { state: { email: currentUser.unverifiedEmail, coming_from: "click" } });
          return;
        }
        navigate("/profile");
      } else {
        navigate({ pathname: location.pathname, hash: "#/auth/login" });
      }
    }
  }, [currentUser, location.pathname, navigate]);

  const containerClasses = isHomePage ? "absolute -bottom-2" : "fixed bottom-0";
  const innerContainerClasses = isHomePage ? "rounded-t-lg py-2" : "rounded-t-lg pt-2 shadow-xl";

  return (
    <div className={`${containerClasses} left-1/2 z-10 w-full -translate-x-1/2 sm:w-[500px]`}>
      <div className={`${innerContainerClasses} w-full overflow-hidden bg-white px-2 `}>
        <div className="flex w-full flex-row items-center justify-center ">
          <div className="w-1/4">
            <button type="button"
                    className={`flex w-full appearance-none flex-col items-center justify-center gap-2 ${isHomePage ? "py-4 rounded-l" : "py-4 rounded-tl"} ${currentSection === "index" ? "bg-green-150" : "bg-white"}`}
                    onClick={() => onClick("index")}>
              <Icon name={currentSection === "index" ? "home" : "home"}
                    className={`block h-6 w-6 ${currentSection === "index" ? "text-green-500" : "text-black"}`} />
              <span className="text-base font-medium text-black">
                {t("menu.index")}
              </span>
            </button>
          </div>
          <div className="w-1/4">
            <button type="button"
                    className={`flex w-full appearance-none flex-col items-center justify-center gap-2 ${isHomePage ? "py-4" : "py-4"} ${currentSection === "map" ? "bg-green-150" : "bg-white"}`}
                    onClick={() => onClick("map")}>
              <Icon name={currentSection === "map" ? "map-selected" : "map"}
                    className={`block h-6 w-6 ${currentSection === "map" ? "text-green-500" : "text-black"}`} />
              <span className="text-base font-medium text-black">
                {t("menu.map")}
              </span>
            </button>
          </div>
          <div className="w-1/4">
            <button type="button"
                    className={`flex w-full appearance-none flex-col items-center justify-center gap-2 ${isHomePage ? "py-4" : "py-4"} ${currentSection === "featured" ? "bg-green-150" : "bg-white"}`}
                    onClick={() => onClick("featured")}>
              <div className="relative">
                <Icon name={currentSection === "featured" ? "star" : "star-outline"}
                      className={`block h-6 w-6 ${currentSection === "featured" ? "text-green-500" : "text-black"}`} />
                {currentSection !== "featured" && clickedFeaturedCount === 0 && featuredEventIds.length > 0 && (
                  <div className="absolute inset-1 bg-green-500  rounded-full animate-ping" />
                )}
              </div>
              <span className="text-base font-medium text-black">
                {t("menu.featured")}
              </span>
            </button>
          </div>
          <div className="w-1/4">
            <button type="button"
                    className={`flex w-full appearance-none flex-col items-center justify-center gap-2 ${isHomePage ? "py-4 rounded-r" : "py-4 rounded-tr"} ${currentSection === "user" ? "bg-green-150" : "bg-white"}`}
                    onClick={() => onClick("user")}>
              {currentUser && currentUser.imageUrl ? (
                <div>
                  <img alt="current user image" className="block rounded-full h-6 w-6" src={currentUser.imageUrl} />
                </div>
              ) : (
                <Icon name={currentSection === "user" ? "user-selected" : "user"}
                      className={`block h-6 w-6 ${currentSection === "user" ? "text-green-500" : "text-black"}`} />
              )}
              <span className="text-base font-medium text-black">
                {t("menu.profile")}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


export default NavBar;
